// import { apiSlice } from '../../../store/apiSlice';
import { apiSlice } from '../../../../store/apiSlice';

export const extendedApiSlice = apiSlice
  .enhanceEndpoints({ addTagTypes: ['packages'] })
  .injectEndpoints({
    endpoints: (builder) => ({
      postEnquiry: builder.mutation({
        query: (payload) => ({
          url: 'ap_crossing/enquiry',
          method: 'post',
          data: payload,
        }),
      }),
    }),
  });

export const { usePostEnquiryMutation } = extendedApiSlice;
